var path = 'widget/lib/extensions-table-widget.tpl.html';
var html = "\n<md-tabs id=\"tabs\" md-border-bottom flex class=\"tb-absolute-fill\" ng-class=\"{'hide-tabs-menu': vm.datasources.length == 1 || vm.tabsHidden}\">\n    <md-tab ng-repeat=\"source in vm.datasources\" label=\"{{ source.name }}\" md-on-select=\"vm.changeSelectedSource(source)\">\n        <tb-extension-table flex entity-id=\"source.entityId\" entity-type=\"{{source.entityType}}\" in-widget=\"true\" ctx=\"vm.ctx\">\n        </tb-extension-table>\n    </md-tab>\n</md-tabs>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/extensions-table-widget.tpl.html
// module id = 1535
// module chunks = 1